import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Card, TextField, Button, Select, MenuItem, Typography, Box, FormControl, Divider, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Row, Col, Container } from 'react-bootstrap';
import axios from 'axios';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Modal from '@mui/material/Modal';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import { IconButton } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from '../SnackbarContext';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import GlobalVariable from "../../services/Global";

// Extend dayjs with required plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const baseApiUrl = GlobalVariable.BASE_API_URL;

const customTheme = createTheme({
    palette: {
        primary: {
            main: "#1976d2",
        },
    },
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    borderRadius: 4,

};

const EditRFP = () => {
    const { id } = useParams();
    const { showSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        id: '',
        first_review: '',
        rfp_issuer: '',
        rfp_type: '',
        location: '',
        budget_range: '',
        expected_timeline: '',
        website: '',
        contact_name: '',
        contact_email: '',
        conference_date: '',
        conference_information: '',
        questionnaire_date: '',
        status: '',
        submission_mode: '',
        submission_date: '',
        remarks: '',
        comments: '',
        internal_poc_name: '', // new field
        additional_status: '', // new field
        timezone: 'Asia/Kolkata', // new timezone field
    });
    const [errors, setErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isEditable, setIsEditable] = useState(true);
    const [firstReviewDialogOpen, setfirstReviewDialogOpen] = useState(false);
    const [comment, setComment] = useState()
    const [isDropdownDisabled, setIsDropdownDisabled] = useState(false);
    const [conferenceDialogOpen, setConferenceDialogOpen] = useState(false);
    const [QuestionnaireDialogOpen, setQuestionnaireDialogOpen] = useState(false);
    const [submissionDialogOpen, setSubmissionDialogOpen] = useState(false);
    const [selectedTimezone, setSelectedTimezone] = useState('Asia/Kolkata');
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isUserChangingTimezone, setIsUserChangingTimezone] = useState(false);

    const [selectedFirstReviewDate, setSelectedFirstReviewDate] = useState(formData.first_review ? dayjs(formData.first_review) : null);
    const [selectedConferenceDate, setSelectedConferenceDate] = useState(formData.conference_date ? dayjs(formData.conference_date) : null);
    const [selectedQuestionnaireDate, setSelectedQuestionnaireDate] = useState(formData.questionnaire_date ? dayjs(formData.questionnaire_date) : null);
    const [selectedSubmissionDate, setSelectedSubmissionDate] = useState(formData.submission_date ? dayjs(formData.submission_date) : null);

    const firstReviewTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedFirstReviewDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedFirstReviewDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:hover': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },

          }),
        },
      },
    },
  },
});

const conferenceTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedConferenceDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedConferenceDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:hover': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            }, 
          }),
        },
      },
    },
  },
});

const questionnaireTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedQuestionnaireDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedQuestionnaireDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:hover': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
        },
      },
    },
  },
});

const submissionTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedSubmissionDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedSubmissionDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:hover': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
        },
      },
    },
  },
});  
    
  useEffect(() => {
    // Helper function to extract date from formatted string for calendar picker
    const extractDateForPicker = (formattedDateString, targetTimezone) => {
      if (!formattedDateString) return null;
      
      // Extract date part before the timezone label (if exists)
      const datePart = formattedDateString.split(' (')[0];
      
      // Parse the date string in the target timezone to avoid conversion issues
      const parsedDate = dayjs.tz(datePart, 'YYYY-MM-DD HH:mm', targetTimezone);
      return parsedDate.isValid() ? parsedDate : null;
    };

    // Only update selected dates when formData is initially loaded or when dates are empty
    if (!selectedFirstReviewDate && formData.first_review) {
      setSelectedFirstReviewDate(extractDateForPicker(formData.first_review, selectedTimezone));
    }
    if (!selectedConferenceDate && formData.conference_date) {
      setSelectedConferenceDate(extractDateForPicker(formData.conference_date, selectedTimezone));
    }
    if (!selectedQuestionnaireDate && formData.questionnaire_date) {
      setSelectedQuestionnaireDate(extractDateForPicker(formData.questionnaire_date, selectedTimezone));
    }
    if (!selectedSubmissionDate && formData.submission_date) {
      setSelectedSubmissionDate(extractDateForPicker(formData.submission_date, selectedTimezone));
    }
  }, [
    formData.first_review,
    formData.conference_date,
    formData.questionnaire_date,
    formData.submission_date,
    selectedFirstReviewDate,
    selectedConferenceDate,
    selectedQuestionnaireDate,
    selectedSubmissionDate,
    selectedTimezone
  ]);
   

    const timezones = [
        { value: 'UTC', label: 'UTC', abbreviation: 'UTC' },
        { value: 'America/New_York', label: 'Eastern Time (ET)', abbreviation: 'ET' },
        { value: 'America/Chicago', label: 'Central Time (CT)', abbreviation: 'CT' },
        { value: 'America/Denver', label: 'Mountain Time (MT)', abbreviation: 'MT' },
        { value: 'America/Los_Angeles', label: 'Pacific Time (PT)', abbreviation: 'PT' },
        { value: 'Asia/Kolkata', label: 'India Standard Time (IST)', abbreviation: 'IST' },
        { value: 'Europe/London', label: 'British Time (GMT)', abbreviation: 'GMT' },
        { value: 'Europe/Paris', label: 'Central European Time (CET)', abbreviation: 'CET' },
        { value: 'Asia/Dubai', label: 'Gulf Standard Time (GST)', abbreviation: 'GST' },
        { value: 'Asia/Singapore', label: 'Singapore Time (SGT)', abbreviation: 'SGT' }
    ];

    // Debug: Log available timezones
    const formatDateTime = (dateString) => {
        if (!dateString) return "";
        const date = dayjs(dateString);
        return date.format('YYYY-MM-DD HH:mm');
    };

 useEffect(() => {
        if (location.state && location.state.formData) {
            const updatedFormData = {
                ...location.state.formData,
                first_review: location.state.formData.first_review ? formatDateTime(location.state.formData.first_review) : '',
                conference_date: location.state.formData.conference_date ? formatDateTime(location.state.formData.conference_date) : '',
                questionnaire_date: location.state.formData.questionnaire_date ? formatDateTime(location.state.formData.questionnaire_date) : '',
                submission_date: location.state.formData.submission_date ? formatDateTime(location.state.formData.submission_date) : '',
            };
            setFormData(updatedFormData);
        }
}, [location.state]);

    useEffect(() => {
        if (isSubmitted) {
            setIsFormValid(validateForm());
        }
    }, [formData, isSubmitted]);

    const formatToISO = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const selectStyles = {
        '& .MuiOutlinedInput-root': { borderRadius: '10px' },
        '& .MuiOutlinedInput-notchedOutline': { borderRadius: '10px', height: '45px' },
        '& .MuiSelect-icon': { top: '8px', color: 'blue' },
        '& .MuiOutlinedInput-input': { paddingTop: '9px' }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'first_review' || name === 'expectedTimeline' || name === 'conference_date' || name === 'questionnaire_date' || name === 'submission_date') {
        }
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

        const handleDateReviewAccept = (newValue) => {
        if (newValue) {
             const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;
            // Format the date in the selected timezone context
            const formattedDate = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
            
            setFormData(prevData => ({
                ...prevData,
                first_review: `${formattedDate} (${selectedTimezoneAbbreviation})`
            }));
            setSelectedFirstReviewDate(newValue);
        }
        setfirstReviewDialogOpen(false);
    };

    const handleFirstReviewDialogClose = () => {
        setfirstReviewDialogOpen(false);
    };

    const validateForm = () => {
        const newErrors = {};

        // if (!formData.first_review) newErrors.first_review = 'First review date is required';
        if (!formData.rfp_issuer) newErrors.rfp_issuer = 'RFP issuer is required';
        if (!formData.rfp_type) newErrors.rfp_type = 'RFP type is required';
        if (!formData.location) newErrors.location = 'Location is required';
        // if (!formData.budget_range) newErrors.budget_range = 'Budget range is required';
        // if (!formData.expected_timeline) newErrors.expected_timeline = 'Expected timeline is required';
        if (!formData.website) newErrors.website = 'Website is required';
        // if (!formData.contact_name) newErrors.contact_name = 'Contact name is required';
        // if (!formData.contact_email) newErrors.contact_email = 'Contact email is required';
        // if (!formData.conference_date) newErrors.conference_date = 'Conference date is required';
        // if (!formData.questionnaire_date) newErrors.questionnaire_date = 'Questionnaire date is required';
        if (!formData.submission_date) newErrors.submission_date = 'Submission date is required';
        if (!formData.status) newErrors.status = 'Status is required';
        if (!formData.submission_mode) newErrors.submission_mode = 'Submission mode is required';
        if (!formData.remarks) newErrors.remarks = 'Remarks are required';
        if (!formData.comments) newErrors.comments = 'Comments are required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);

    };

    const getTimezoneLabel = (tzValue) => {
        const tz = timezones.find(tz => tz.value === tzValue);
        return tz ? tz.label : '';
    };

    const getTimezoneAbbreviation = (tzValue) => {
        const tz = timezones.find(tz => tz.value === tzValue);
        return tz ? tz.abbreviation : '';
    };

    // Helper function to map timezone abbreviation to timezone value
    const mapTimezoneAbbreviationToValue = (abbreviation) => {
        if (!abbreviation) return null;
        const tz = timezones.find(tz => tz.abbreviation === abbreviation);    
        return tz ? tz.value : null;
    };

    const handleSave = async () => {
        setIsSubmitted(true);
        if (!validateForm()) return;
        setLoading(true);
        try {           
            // Extract date from formatted string for submission
            const extractDateFromFormatted = (formattedDateString) => {
                if (!formattedDateString) return "";
                // Extract date part before the timezone label
                const datePart = formattedDateString.split(' (')[0];
                return datePart;
            };

            // Get the current timezone abbreviation
            const tzAbbreviation = getTimezoneAbbreviation(formData.timezone);

            // Prepare request data
            const requestData = {
                rfpid: id,
                first_review: extractDateFromFormatted(formData.first_review),
                first_review_date_timezone: tzAbbreviation,
                rfp_issuer: formData.rfp_issuer,
                rfp_type: formData.rfp_type,
                location: formData.location,
                budget_range: formData.budget_range || "0",
                expected_timeline: formData.expected_timeline || "",
                website: formData.website,
                contact_name: formData.contact_name || "NA",
                contact_email: formData.contact_email || "NA",
                conference_date: extractDateFromFormatted(formData.conference_date),
                conference_date_timezone: tzAbbreviation,
                conference_information: formData.conference_information || "",
                questionnaire_date: extractDateFromFormatted(formData.questionnaire_date),
                questionnaire_date_timezone: tzAbbreviation,
                submission_mode: formData.submission_mode,
                submission_date: extractDateFromFormatted(formData.submission_date),
                submission_date_timezone: tzAbbreviation,
                status: formData.status,
                conference_reason: "",
                questionnaire_reason: "",
                internal_poc_name: formData.internal_poc_name || "",
                additional_status: formData.additional_status || "",
            };


            const response = await axios.put(`${baseApiUrl}/dashboard/editrfp`, requestData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.status_code === 200) {
                setIsEditable(false);
                navigate('/dashboard');
                showSnackbar("RFP updated successfully", "success");
            }

        } catch (error) {
            console.error('Error updating RFP:', error);
            showSnackbar("Error updating RFP", "error");
        }
        finally {
            setLoading(false);
        }
    };

    const handleSaveComment = () => {
        const storedData = JSON.parse(localStorage.getItem('userDetails'));
        const userId = storedData.userDetails.id;

        const commentData = {
            userid: userId,
            comments: comment,
            rfpid: id,
            status: ''
        }
        axios.post(`${baseApiUrl}/dashboard/addrfpcomment`, commentData)
            .then(response => {
                setIsDropdownDisabled(true);
                showSnackbar("Comment updated successfully", "success");
                handleClose();

            })
            .catch(error => {
                console.error('Error saving comment:', error.response.data);
            });
    }

    const handleConferenceDateAccept = (newValue) => {
        if (newValue) {
            const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;
            // Format the date in the selected timezone context
            const formattedDate = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
            
            setFormData(prevData => ({   
                ...prevData,
                conference_date: `${formattedDate} (${selectedTimezoneAbbreviation})`
            }));
            setSelectedConferenceDate(newValue);
        }        
        setConferenceDialogOpen(false);
    };

    const handleConferenceDialogClose = () => {
        setConferenceDialogOpen(false);
    };

    const handleQuestionnaireDateAccept = (newValue) => {
        if (newValue) {
            const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;
            // Format the date in the selected timezone context
            const formattedDate = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
            
            setFormData(prevData => ({
                ...prevData,
                questionnaire_date: `${formattedDate} (${selectedTimezoneAbbreviation})`
            }));
            setSelectedQuestionnaireDate(newValue);
        }
        setQuestionnaireDialogOpen(false);
    };

    const handleQuestionnaireDialogClose = () => {
        setQuestionnaireDialogOpen(false);
    };

        const handleSubmissionDateAccept = (newValue) => {
        if (newValue) {
         const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;
            // Format the date in the selected timezone context
            const formattedDate = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
            
            setFormData(prevData => ({
                ...prevData,
                submission_date: `${formattedDate} (${selectedTimezoneAbbreviation})`
            }));  
            setSelectedSubmissionDate(newValue);
        }
        setSubmissionDialogOpen(false);
    };

    const handleDialogClose = () => {
        setSubmissionDialogOpen(false);
    };

    // Unified timezone change handler for all fields
    const handleAllFieldsTimezoneChange = (newTimezone) => {
        // Set flag to prevent useEffect from overriding user selection
        setIsUserChangingTimezone(true);
        
        const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === newTimezone)?.abbreviation;

        // Update the formData timezone field
        setFormData(prevData => ({
            ...prevData,
            timezone: newTimezone
        }));

        // Helper to convert and update a field
        const convertAndUpdate = (formKey) => {
            const currentDateString = formData[formKey];
            if (currentDateString) {
                // Extract the date part from the current formatted string
                const datePart = currentDateString.split(' (')[0];
                
                // Parse the date in the original timezone context
                const originalDate = dayjs.tz(datePart, 'YYYY-MM-DD HH:mm', selectedTimezone);
                
                // Convert to the new timezone
                const convertedDate = originalDate.tz(newTimezone);
                const formattedDate = convertedDate.format('YYYY-MM-DD HH:mm');
                
                setFormData(prevData => ({
                    ...prevData,
                    [formKey]: `${formattedDate} (${selectedTimezoneAbbreviation})`
                }));
                
                // Return the converted date for the calendar picker
                return convertedDate;
            }
            return null;
        };

        // Convert and update all fields immediately
        const newFirstReviewDate = convertAndUpdate('first_review');
        const newConferenceDate = convertAndUpdate('conference_date');
        const newQuestionnaireDate = convertAndUpdate('questionnaire_date');
        const newSubmissionDate = convertAndUpdate('submission_date');

        // Update the selected date states with the converted dates immediately
        if (newFirstReviewDate) setSelectedFirstReviewDate(newFirstReviewDate);
        if (newConferenceDate) setSelectedConferenceDate(newConferenceDate);
        if (newQuestionnaireDate) setSelectedQuestionnaireDate(newQuestionnaireDate);
        if (newSubmissionDate) setSelectedSubmissionDate(newSubmissionDate);

        // Update selectedTimezone last to ensure all conversions are done first
        setSelectedTimezone(newTimezone);
        
        // Reset the flag after a short delay to allow useEffect to work again
        setTimeout(() => {
            setIsUserChangingTimezone(false);
        }, 1000);
    };

    // Replace all individual handlers with the unified one
    const handleFirstReviewTimezoneChange = handleAllFieldsTimezoneChange;
    const handleConferenceTimezoneChange = handleAllFieldsTimezoneChange;
    const handleQuestionnaireTimezoneChange = handleAllFieldsTimezoneChange;
    const handleSubmissionTimezoneChange = handleAllFieldsTimezoneChange;

    // Helper to extract timezone from a date string like '2025-07-14 03:30 (IST)' or '2025-07-14 03:30 (India Standard Time (IST))'
    const extractTimezoneFromDateString = (dateString) => {
        if (!dateString) return null;
        
        // First try to match timezone in parentheses at the end
        const match = dateString.match(/\(([^)]+)\)$/);
        if (match && match[1]) {
            const timezoneText = match[1].trim();
            
            // Try to map label back to value first
            let tz = timezones.find(tz => tz.label === timezoneText);
            if (tz) return tz.value;
            
            // If not found by label, try to map abbreviation back to value
            tz = timezones.find(tz => tz.abbreviation === timezoneText);
            if (tz) return tz.value;
            
            // If still not found, try to find by partial match in label
            tz = timezones.find(tz => tz.label.includes(timezoneText));
            if (tz) return tz.value;
            
            return null;
        }
        
        // If no parentheses found, try to extract timezone from the end of the string
        // This handles cases like "Jul-09-2025 20:29CET"
        const timezoneMatch = dateString.match(/([A-Z]{2,4})$/);
        if (timezoneMatch && timezoneMatch[1]) {
            const timezoneText = timezoneMatch[1].trim();
            
            // Try to map abbreviation back to value
            let tz = timezones.find(tz => tz.abbreviation === timezoneText);
            if (tz) return tz.value;
            
            // If not found by abbreviation, try to find by partial match in label
            tz = timezones.find(tz => tz.label.includes(timezoneText));
            if (tz) return tz.value;
            
            return null;
        }
        
        return null;
    };

    // On mount or when formData changes, set the timezone from any non-empty field, else default to IST
    useEffect(() => {
        // Only update timezone if not currently changing due to user interaction
        if (!isUserChangingTimezone) {
            // First, try to extract timezone from formatted date strings
            const tzFromFirstReview = extractTimezoneFromDateString(formData.first_review);
            const tzFromConference = extractTimezoneFromDateString(formData.conference_date);
            const tzFromQuestionnaire = extractTimezoneFromDateString(formData.questionnaire_date);
            const tzFromSubmission = extractTimezoneFromDateString(formData.submission_date);
            
            // If no timezone found in formatted strings, check the separate timezone fields
            let foundTz = tzFromFirstReview || tzFromConference || tzFromQuestionnaire || tzFromSubmission;
            
            if (!foundTz) {
                // Check separate timezone fields
                const tzFromFirstReviewField = mapTimezoneAbbreviationToValue(formData.first_review_date_timezone);
                const tzFromConferenceField = mapTimezoneAbbreviationToValue(formData.conference_date_timezone);
                const tzFromQuestionnaireField = mapTimezoneAbbreviationToValue(formData.questionnaire_date_timezone);
                const tzFromSubmissionField = mapTimezoneAbbreviationToValue(formData.submission_date_timezone);
                
                foundTz = tzFromFirstReviewField || tzFromConferenceField || tzFromQuestionnaireField || tzFromSubmissionField;
            }
            if (foundTz) {
                setSelectedTimezone(foundTz);
                // Also update the formData timezone field
                setFormData(prevData => ({
                    ...prevData,
                    timezone: foundTz
                }));
            } else {
                setSelectedTimezone('Asia/Kolkata');
                setFormData(prevData => ({
                    ...prevData,
                    timezone: 'Asia/Kolkata'
                }));
            }
        }
    }, [formData.first_review, formData.conference_date, formData.questionnaire_date, formData.submission_date, formData.first_review_date_timezone, formData.conference_date_timezone, formData.questionnaire_date_timezone, formData.submission_date_timezone, isUserChangingTimezone]);

    // Update formData timezone when selectedTimezone changes
    useEffect(() => {
        setFormData(prevData => ({
            ...prevData,
            timezone: selectedTimezone
        }));
    }, [selectedTimezone]);

    // Initial timezone setup when component mounts
    useEffect(() => {
        if (location.state && location.state.formData) {
            // Check if any date field has timezone information and set it as default
            const data = location.state.formData;
            
            // First, try to extract timezone from formatted date strings
            const tzFromFirstReview = extractTimezoneFromDateString(data.first_review);
            const tzFromConference = extractTimezoneFromDateString(data.conference_date);
            const tzFromQuestionnaire = extractTimezoneFromDateString(data.questionnaire_date);
            const tzFromSubmission = extractTimezoneFromDateString(data.submission_date);
            
            // If no timezone found in formatted strings, check the separate timezone fields
            let foundTz = tzFromFirstReview || tzFromConference || tzFromQuestionnaire || tzFromSubmission;
            
            if (!foundTz) {
                // Check separate timezone fields
                const tzFromFirstReviewField = mapTimezoneAbbreviationToValue(data.first_review_date_timezone);
                const tzFromConferenceField = mapTimezoneAbbreviationToValue(data.conference_date_timezone);
                const tzFromQuestionnaireField = mapTimezoneAbbreviationToValue(data.questionnaire_date_timezone);
                const tzFromSubmissionField = mapTimezoneAbbreviationToValue(data.submission_date_timezone);
                
                foundTz = tzFromFirstReviewField || tzFromConferenceField || tzFromQuestionnaireField || tzFromSubmissionField;
            }

            if (foundTz) {
                setSelectedTimezone(foundTz);
                setFormData(prevData => ({
                    ...prevData,
                    timezone: foundTz
                }));
            }
        }
    }, [location.state]);

    return (
        <Container fluid className='ps-3 pt-2 rfpDtailsContainer'>
            <div>
                <Card className='rounded-3'>
                    <Box style={{ paddingBottom: '16px' }}>
                        <div style={{ padding: '16px 0' }}>
                            <Row className="mb-2 align-items-center mx-1">
                                <Col xs={12} sm={6} md={6}>
                                    <Typography className='fontstylee MicroSoftRFPDetails_heading' sx={{ width: 'auto', whiteSpace: 'nowrap' }}>
                                        Edit RFP Details
                                    </Typography>
                                </Col>
                                <Col xs={12} sm={6} md={6} className=" d-flex justify-content-end">
                                    <Button className='border-primary text-primary text-capitalize rounded-2 '
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                        <form style={{ marginTop: '6px' }}>
                            <Container fluid className=''>
                                <Backdrop
                                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                                    open={loading}
                                >
                                    <CircularProgress className=' text-primary' />
                                </Backdrop>

                                <Box
                                    sx={{
                                        border: '1px solid #ccc',
                                        borderRadius: '10px',
                                        padding: '16px',
                                        position: 'relative'
                                    }}
                                    className='mb-5'
                                >
                                    <Typography
                                                      className="fontstylee"
                                                      sx={{
                                                        position: "absolute",
                                                        top: "-10px",
                                                        left: "20px",
                                                        background: "#fff",
                                                        padding: "0 8px",
                                                        fontSize: "16px",
                                                      }}
                                                    >
                                                      RFP Details
                                                    </Typography>
                                    <Row className='pb-2'>



                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                                                <Typography className='fontstyleet' variant="h6" gutterBottom>
                                                    First Review
                                                </Typography>
                                                <TextField
                                                    name="first_review"
                                                    value={formData.first_review || ''}
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder="Select date"
                                                    InputProps={{
                                                        readOnly: true,
                                                        endAdornment: (
                                                            <IconButton
                                                                onClick={() => setfirstReviewDialogOpen(true)}
                                                                color="primary"
                                                                size="large"
                                                            >
                                                                <CalendarMonthIcon sx={{ color: '#0175FF' }} />
                                                            </IconButton>
                                                        ),
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                />
                                                {errors.first_review && (
                                                    <Typography color="error">{errors.first_review}</Typography>
                                                )}

                                                <Dialog
                                                    open={firstReviewDialogOpen}
                                                    onClose={handleFirstReviewDialogClose}
                                                    maxWidth="xs"
                                                    fullWidth
                                                    PaperProps={{
                                                        style: {
                                                            height: '85%',
                                                            width: '100%',
                                                            borderRadius: '12px',
                                                            position: 'fixed',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            overflow: 'auto',
                                                        },
                                                    }}
                                                    className='dialogpaperstyles'
                                                >
                                                                                                            <DialogTitle>
                                                        Select First Review and Time
                                                        <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                                                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                                                        </Typography>
                                                        <Box sx={{ mt: 1 }}>
                                                            <FormControl fullWidth size="small">
                                                                <Select
                                                                    value={selectedTimezone}
                                                                    onChange={(e) => handleFirstReviewTimezoneChange(e.target.value)}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            borderRadius: '8px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {timezones.map((timezone) => (
                                                                        <MenuItem key={timezone.value} value={timezone.value}>
                                                                            {timezone.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                        <IconButton
                                                            edge="end"
                                                            color="inherit"
                                                            onClick={handleFirstReviewDialogClose}
                                                            aria-label="close"
                                                            sx={{
                                                                position: 'absolute',
                                                                right: 9,
                                                                top: 8,
                                                                color: (theme) => theme.palette.grey[500],
                                                            }}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <ThemeProvider theme={firstReviewTheme}>
                                                                <StaticDateTimePicker
                                                                    value={selectedFirstReviewDate}
                                                                    onAccept={handleDateReviewAccept}
                                                                    onClose={handleFirstReviewDialogClose}
                                                                    ampm={false}
                                                                    timezone={selectedTimezone}
                                                                />
                                                            </ThemeProvider>
                                                        </LocalizationProvider>
                                                    </DialogContent>
                                                </Dialog>
                                            </FormControl>
                                        </Col>

                                        <Col lg={6} md={6}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>RFP ISSUER<span style={{ color: "#ff0000" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Issuer Name"
                                                    name="rfp_issuer"
                                                    onChange={handleInputChange}
                                                    autoComplete='off'
                                                    value={formData.rfp_issuer}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                    error={isSubmitted && !!errors.rfp_issuer}
                                                    helperText={isSubmitted && errors.rfp_issuer}
                                                    disabled={!isEditable}

                                                />
                                            </FormControl>
                                        </Col>
                                        <Col lg={3}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Rfp Type<span style={{ color: "#ff0000" }}>*</span></Typography>
                                                <Select
                                                    value={formData.rfp_type}
                                                    onChange={handleInputChange}
                                                    name="rfp_type"
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderRadius: '10px',
                                                            height: '45px',
                                                        },
                                                        '& .MuiSelect-icon': {
                                                            top: '8px',
                                                            color: 'blue',
                                                        },
                                                        '& .MuiOutlinedInput-input': {
                                                            paddingTop: '9px',
                                                        },
                                                    }}
                                                    error={isSubmitted && !!errors.rfp_type}
                                                    disabled={!isEditable}
                                                >
                                                    <MenuItem className='subheader' value="Solutioning">Solutioning</MenuItem>
                                                    <MenuItem className='subheader' value="Staffing">Staffing</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Location<span style={{ color: "#ff0000" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Location"
                                                    name="location"
                                                    value={formData.location}
                                                    autoComplete='off'
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}

                                                    onChange={handleInputChange}
                                                    error={isSubmitted && !!errors.location}
                                                    helperText={isSubmitted && errors.location}
                                                    disabled={!isEditable}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Budget Range($)</Typography>
                                                <TextField
                                                    placeholder="Budget Range"
                                                    name="budget_range"
                                                    value={formData.budget_range}
                                                    type="number"
                                                    onKeyPress={(event) => {
                                                        // Allow only numbers and prevent other characters
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                    onChange={handleInputChange}
                                                    error={isSubmitted && !!errors.budget_range}
                                                    helperText={isSubmitted && errors.budget_range}
                                                    disabled={!isEditable}
                                                    autoComplete='off'

                                                />
                                            </FormControl>
                                        </Col>
                                        <Col lg={3}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Expected Timeline(In months)</Typography>
                                                <TextField
                                                    placeholder="Expected Timeline"
                                                    name="expected_timeline"
                                                    value={formData.expected_timeline}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                    onChange={handleInputChange}
                                                    error={isSubmitted && !!errors.expected_timeline}
                                                    helperText={isSubmitted && errors.expected_timeline}
                                                    disabled={!isEditable}
                                                    autoComplete='off'

                                                />
                                            </FormControl>
                                        </Col>
                                        <Col lg={3}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Website<span style={{ color: "#ff0000" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Website"
                                                    name="website"
                                                    autoComplete='off'
                                                    value={formData.website}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                    onChange={handleInputChange}
                                                    error={isSubmitted && !!errors.website}
                                                    helperText={isSubmitted && errors.website}
                                                    disabled={!isEditable}

                                                />
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </Box>
                                <Box
                                    sx={{
                                        border: '1px solid #ccc',
                                        borderRadius: '10px',
                                        padding: '16px',

                                        position: 'relative'
                                    }}
                                    className='mb-5'

                                >
                                   <Typography
                                                     className="fontstylee"
                                                     sx={{
                                                       position: "absolute",
                                                       top: "-10px",
                                                       left: "20px",
                                                       background: "#fff",
                                                       padding: "0 8px",
                                                       fontSize: "16px",
                                                     }}
                                                   >
                                                     Point of Contact Details
                                                   </Typography>
                                   
                                    <Row>
                                        <Col lg={3}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Name</Typography>
                                                <TextField
                                                    placeholder="contact_name"
                                                    name="contact_name"
                                                    value={formData.contact_name}
                                                    autoComplete='off'
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                    onChange={handleInputChange}
                                                    error={isSubmitted && !!errors.contact_name}
                                                    helperText={isSubmitted && errors.contact_name}
                                                    disabled={!isEditable}

                                                />
                                            </FormControl>
                                        </Col>
                                        <Col lg={3}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Email</Typography>
                                                <TextField
                                                    placeholder="contact_email"
                                                    name="contact_email"
                                                    value={formData.contact_email}
                                                    autoComplete='off'
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                    onChange={handleInputChange}
                                                    error={isSubmitted && !!errors.contact_email}
                                                    helperText={isSubmitted && errors.contact_email}
                                                    disabled={!isEditable}

                                                />
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </Box>
                                <Box
                                    sx={{
                                        border: '1px solid #ccc',
                                        borderRadius: '10px',
                                        padding: '16px',

                                        position: 'relative'
                                    }}
                                    className='mb-5'
                                >
                                    <Typography
                                                      className="fontstylee"
                                                      sx={{
                                                        position: "absolute",
                                                        top: "-10px",
                                                        left: "20px",
                                                        background: "#fff",
                                                        padding: "0 8px",
                                                        fontSize: "16px",
                                                      }}
                                                    >
                                                    Submission Details
                                                    </Typography>
                                    <Row className='pb-2'>


                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className="mt-2 inputfields" >
                                                <Typography variant="h6" className='fontstyleet' gutterBottom>
                                                    Conference Date
                                                </Typography>
                                                <TextField
                                                    name="conference_date"
                                                    value={formData.conference_date || ''}
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder="Select date"
                                                    InputProps={{
                                                        readOnly: true,
                                                        endAdornment: (
                                                            <IconButton
                                                                onClick={() => setConferenceDialogOpen(true)}
                                                                color="primary"
                                                                size="large"
                                                            >
                                                                <CalendarMonthIcon sx={{ color: '#0175FF' }} />
                                                            </IconButton>
                                                        ),
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                />
                                                {errors.conference_date && (
                                                    <Typography color="error">{errors.conference_date}</Typography>
                                                )}

                                                <Dialog
                                                    open={conferenceDialogOpen}
                                                    onClose={handleConferenceDialogClose}
                                                    maxWidth="xs"
                                                    fullWidth
                                                    PaperProps={{
                                                        style: {
                                                            height: '85%',
                                                            width: '100%',
                                                            borderRadius: '12px',
                                                            position: 'fixed',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            overflow: 'auto',
                                                        },
                                                    }}
                                                >
                                                    <DialogTitle>
                                                        Select Conference Date and Time
                                                        <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                                                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                                                        </Typography>
                                                        <Box sx={{ mt: 1 }}>
                                                            <FormControl fullWidth size="small">
                                                                <Select
                                                                    value={selectedTimezone}
                                                                    onChange={(e) => handleConferenceTimezoneChange(e.target.value)}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            borderRadius: '8px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {timezones.map((timezone) => (
                                                                        <MenuItem key={timezone.value} value={timezone.value}>
                                                                            {timezone.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                        <IconButton
                                                            edge="end"
                                                            color="inherit"
                                                            onClick={handleConferenceDialogClose}
                                                            aria-label="close"
                                                            sx={{
                                                                position: 'absolute',
                                                                right: 9,
                                                                top: 8,
                                                                color: (theme) => theme.palette.grey[500],
                                                            }}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <ThemeProvider theme={conferenceTheme}>
                                                                <StaticDateTimePicker
                                                                    value={selectedConferenceDate}
                                                                    onAccept={handleConferenceDateAccept}
                                                                    onClose={handleConferenceDialogClose}
                                                                    ampm={false}
                                                                    timezone={selectedTimezone}
                                                                />
                                                            </ThemeProvider>
                                                        </LocalizationProvider>
                                                    </DialogContent>
                                                </Dialog>
                                            </FormControl>
                                        </Col>

                                        



                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className='mt-2 inputfields'>
                                                <Typography variant="h6" className='fontstyleet' gutterBottom>
                                                    Questionnaire Date
                                                </Typography>
                                                <TextField
                                                    name="questionnaire_date"
                                                    value={formData.questionnaire_date || ''}    
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder="Select date"
                                                    InputProps={{
                                                        readOnly: true,
                                                        endAdornment: (
                                                            <IconButton
                                                                onClick={() => setQuestionnaireDialogOpen(true)}
                                                                color="primary"
                                                                size="large"
                                                            >
                                                                <CalendarMonthIcon sx={{ color: '#0175FF' }} />
                                                            </IconButton>
                                                        ),
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px'
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px'
                                                        }
                                                    }}
                                                />
                                                {errors.questionnaire_date && <Typography color="error">{errors.questionnaire_date}</Typography>}

                                                <Dialog
                                                    open={QuestionnaireDialogOpen}
                                                    onClose={handleQuestionnaireDialogClose}
                                                    maxWidth="xs"
                                                    fullWidth
                                                    PaperProps={{
                                                        style: {
                                                            height: '85%',
                                                            width: '100%',
                                                            borderRadius: '12px',
                                                            position: 'fixed',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            overflow: 'auto',
                                                        },
                                                    }}
                                                >
                                                    <DialogTitle>
                                                        Select Questionnaire Date and Time
                                                        <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                                                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                                                        </Typography>
                                                        <Box sx={{ mt: 1 }}>
                                                            <FormControl fullWidth size="small">
                                                                <Select
                                                                    value={selectedTimezone}
                                                                    onChange={(e) => handleQuestionnaireTimezoneChange(e.target.value)}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            borderRadius: '8px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {timezones.map((timezone) => (
                                                                        <MenuItem key={timezone.value} value={timezone.value}>
                                                                            {timezone.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                        <IconButton
                                                            edge="end"
                                                            color="inherit"
                                                            onClick={handleQuestionnaireDialogClose}
                                                            aria-label="close"
                                                            sx={{
                                                                position: 'absolute',
                                                                right: 9,
                                                                top: 8,
                                                                color: (theme) => theme.palette.grey[500]
                                                            }}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <ThemeProvider theme={questionnaireTheme}>
                                                                <StaticDateTimePicker
                                                                    value={selectedQuestionnaireDate}
                                                                    onAccept={handleQuestionnaireDateAccept}
                                                                    onClose={handleQuestionnaireDialogClose}
                                                                    ampm={false}
                                                                    timezone={selectedTimezone}
                                                                />
                                                            </ThemeProvider>
                                                        </LocalizationProvider>
                                                    </DialogContent>

                                                </Dialog>
                                            </FormControl>
                                        </Col>

                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Status<span style={{ color: "#ff0000" }}>*</span></Typography>
                                                <Select
                                                    value={formData.status}
                                                    onChange={handleInputChange}
                                                    name="status"
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                            top: '2px'
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderRadius: '10px',
                                                            height: '45px',
                                                        },
                                                        '& .MuiSelect-icon': {
                                                            top: '8px',
                                                            color: 'blue',
                                                        },
                                                        '& .MuiOutlinedInput-input': {
                                                            paddingTop: '9px',
                                                        },
                                                    }}
                                                    error={isSubmitted && !!errors.status}
                                                    helperText={isSubmitted && errors.status}
                                                    disabled={isDropdownDisabled || !isEditable}

                                                >
                                                    <MenuItem value="1">New</MenuItem>
                                                    <MenuItem value="2">In Progress</MenuItem>
                                                    <MenuItem value="3" onClick={handleOpen}>On Hold</MenuItem>
                                                    <MenuItem value="4">Submitted</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Submission Mode<span style={{ color: "#ff0000" }}>*</span></Typography>
                                                <Select
                                                    value={formData.submission_mode}
                                                    onChange={handleInputChange}
                                                    name="submission_mode"
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderRadius: '10px',
                                                            height: '45px',
                                                        },
                                                        '& .MuiSelect-icon': {
                                                            top: '8px',
                                                            color: 'blue',
                                                        },
                                                        '& .MuiOutlinedInput-input': {
                                                            paddingTop: '9px',
                                                        },
                                                    }}
                                                    error={isSubmitted && !!errors.submission_mode}
                                                    helperText={isSubmitted && errors.submission_mode}
                                                    disabled={!isEditable}

                                                >
                                                    <MenuItem value="Portal">Portal</MenuItem>
                                                    <MenuItem value="Email">Email</MenuItem>
                                                    <MenuItem value="Physical">Physical</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                    <Row>
                                       

                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className='mt-2 inputfields'>
                                                <Typography variant="h6" className='fontstyleet' gutterBottom>
                                                    Submission Date<span style={{ color: "#ff0000" }}>*</span>
                                                </Typography>
                                                <TextField
                                                    name="submission_date"
                                                    value={formData.submission_date || ''}
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder="Select date"
                                                    InputProps={{
                                                        readOnly: true,
                                                        endAdornment: (
                                                            <IconButton
                                                                onClick={() => setSubmissionDialogOpen(true)}
                                                                color="primary"
                                                                size="large"
                                                            >
                                                                <CalendarMonthIcon sx={{ color: '#0175FF' }} />
                                                            </IconButton>
                                                        ),
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px'
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px'
                                                        }
                                                    }}
                                                />
                                                {errors.submission_date && <Typography color="error">{errors.submission_date}</Typography>}

                                                <Dialog
                                                    open={submissionDialogOpen}
                                                    onClose={handleDialogClose}
                                                    maxWidth="xs"
                                                    fullWidth
                                                    PaperProps={{
                                                        style: {
                                                            height: '85%',
                                                            width: '100%',
                                                            borderRadius: '12px',
                                                            position: 'fixed',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            overflow: 'auto',
                                                        },
                                                    }}
                                                >
                                                    <DialogTitle>
                                                        Select Submission Date and Time
                                                        <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                                                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                                                        </Typography>
                                                        <Box sx={{ mt: 1 }}>
                                                            <FormControl fullWidth size="small">
                                                                <Select
                                                                    value={selectedTimezone}
                                                                    onChange={(e) => handleSubmissionTimezoneChange(e.target.value)}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            borderRadius: '8px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {timezones.map((timezone) => (
                                                                        <MenuItem key={timezone.value} value={timezone.value}>
                                                                            {timezone.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                        <IconButton
                                                            edge="end"
                                                            color="inherit"
                                                            onClick={handleDialogClose}
                                                            aria-label="close"
                                                            sx={{
                                                                position: 'absolute',
                                                                right: 9,
                                                                top: 8,
                                                                color: (theme) => theme.palette.grey[500]
                                                            }}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <ThemeProvider theme={submissionTheme}>
                                                                <StaticDateTimePicker
                                                                    value={selectedSubmissionDate}
                                                                    onAccept={handleSubmissionDateAccept}
                                                                    onClose={handleDialogClose}
                                                                    ampm={false}
                                                                    timezone={selectedTimezone}
                                                                />
                                                            </ThemeProvider>
                                                        </LocalizationProvider>
                                                    </DialogContent>

                                                </Dialog>
                                            </FormControl>
                                        </Col>
                                        <Col lg={3}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Internal POC Name</Typography>
                                                <TextField
                                                    placeholder="Name"
                                                    name="internal_poc_name"
                                                    value={formData.internal_poc_name}
                                                    autoComplete='off'
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: '40px',
                                                        },
                                                    }}
                                                    onChange={handleInputChange}
                                                    disabled={!isEditable}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col lg={3} md={6}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Additional Status</Typography>
                                                <Select
                                                    name="additional_status"
                                                    value={formData.additional_status}
                                                    onChange={handleInputChange}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                            top: '2px'
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderRadius: '10px',
                                                            height: '45px',
                                                        },
                                                        '& .MuiSelect-icon': {
                                                            top: '8px',
                                                            color: 'blue',
                                                        },
                                                        '& .MuiOutlinedInput-input': {
                                                            paddingTop: '9px',
                                                        },
                                                    }}
                                                    disabled={isDropdownDisabled || !isEditable}
                                                >
                                                    
                                                    <MenuItem value="Go">Go</MenuItem>
                                                    <MenuItem value="No Go">No Go</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <FormControl fullWidth margin="normal" className="inputfields">
                                                <Typography>Conference Information</Typography>
                                                <TextField
                                                    placeholder="Conference Information"
                                                    name="conference_information"
                                                    value={formData.conference_information}
                                                    autoComplete='off'
                                                    multiline
                                                    minRows={1}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            height: 'auto',
                                                        },
                                                    }}
                                                    onChange={handleInputChange}
                                                    error={isSubmitted && !!errors.conference_information}
                                                    helperText={isSubmitted && errors.conference_information}
                                                    disabled={!isEditable}
                                                />
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </Box>
                              
                                <Box sx={{ display: "flex", justifyContent: 'end', marginTop: '10px' }}>
                                    <Button
                                        variant="contained"
                                        className={`bg-primary text-capitalize rounded-3 `}
                                        onClick={handleSave}
                                    >
                                        Save
                                    </Button>
                                </Box>
                            </Container>
                        </form>
                    </Box>
                </Card>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className='commentsModal'>
                    <Box display="flex" justifyContent="space-between" alignItems="baseline" >
                        <Typography gutterBottom className='commentsText'>
                            Comments
                        </Typography>
                        <CloseIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                    </Box>
                    <Divider style={{ borderColor: '#adadad' }} />
                    <Typography id="modal-modal-description" sx={{ mt: 2 }} className='addCommentText'>
                        Add Comments
                    </Typography>
                    <TextField
                        fullWidth
                        label="Comment"
                        variant="outlined"
                        className=' mb-2 rounded-5 mt-3'
                        multiline
                        rows={2}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '16px',
                            },
                        }}
                    />
                    <Button variant="contained" className="mb-2 mt-1 float-end bg-primary rounded-5 " onClick={handleSaveComment}>
                        Save
                    </Button>

                </Box>
            </Modal>
        </Container>
    );
};

export default EditRFP;